import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';
import {
  border,
  BorderProps,
  color,
  ColorProps,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  system,
  typography,
  TypographyProps,
  width,
  WidthProps,
} from 'styled-system';

const gap = system({
  gap: {
    property: 'gap',
    scale: 'space',
  },
});

export type BoxProps = HTMLAttributes<HTMLDivElement> &
  BorderProps &
  SpaceProps &
  ColorProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  PositionProps &
  TypographyProps &
  WidthProps & {
    children?: React.ReactNode;
    gap?: unknown;
    className?: string;
  };

const Box = styled.div<BoxProps>`
  ${position}
  ${color};
  ${typography};
  ${space};
  ${width};
  ${layout}
  ${flexbox};
  ${grid};
  ${gap};
  ${border};
`;

export default Box;
